import type { TagCondition } from 'dorian-shared/types/branch/HubOption';

export function isTagConditionValid(c: TagCondition): boolean {
  const subsValid = c.subConditions.length > 0 && c.subConditions.every((sub) => {
    if (sub.variableId == null) return false;
    const hasInt = sub.intValue !== undefined && sub.intValue !== '';
    const hasVar = sub.varValue !== undefined && sub.varValue !== null && sub.varValue !== 0;
    return hasInt || hasVar;
  });
  if (!subsValid) return false;
  return c.tagTemplateId != null && c.tagTemplateId > 0;
}
